import { observer } from "mobx-react-lite";
import styles from "./NotePatches.module.css";
import SettingIcon from "@/assets/icons/common/setting.svg?react";
import { CancelButton } from "@/components/button/SaveEditCancel/CancelButton";
import { InputAndLabelTextBox } from "@/components/input/InputAndLabelTextBox/InputAndLabelTextBox";
import { formNotesStore } from "@/stores/NotesStore";

export const Top = observer(
  ({
    id,
    title,
    version,
    date_create,
    editMode,
  }: {
    id: number;
    title: string;
    version: number;
    date_create: string;
    editMode?: boolean;
  }) => {
    const format = (date: string) => {
      return new Date(date).toLocaleString("ru-RU", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    };

    return (
      <div className={styles.title}>
        <div className={styles.leftTop}>
          <SettingIcon />
          {editMode ? (
            <InputAndLabelTextBox
              idAndForHTML={`title${id}`}
              labelText="Заголовок"
              props={{
                defaultValue: title,
                placeholder: "",
                onChange: (e: React.ChangeEvent<HTMLInputElement>): void =>
                  formNotesStore.updateTitle(id, e.target.value),
              }}
            />
          ) : (
            <h3>{title}</h3>
          )}
        </div>
        {!editMode && (
          <span>
            Версия изменений: <b>{version}</b> от {format(date_create)}
          </span>
        )}
        {editMode && <CancelButton onClick={() => formNotesStore.removeNote(id)}>Удалить</CancelButton>}
      </div>
    );
  },
);
